var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solution"},[_c('basepanel',[_c('div',{staticClass:"sol-title"},[_vm._v("解决方案")]),_c('div',{staticClass:"outer-box"},[_c('lists',{attrs:{"categoryId":_vm.id,"prePath":_vm.prePath}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }